import { render, staticRenderFns } from "./IfBlockFormField.vue?vue&type=template&id=3708608f&"
import script from "./IfBlockFormField.vue?vue&type=script&lang=js&"
export * from "./IfBlockFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports